export function formatValueToCsvXlsx(value) {
    const number = parseFloat(value);
    if (isNaN(number)) return "";
    const absValue = Math.abs(number).toFixed(2).replace('.', ',');
    return number < 0 ? `-${absValue}` : absValue;
}